import {
  FETCH_INSTANCE_CPU_AGGREGATE,
  FETCH_INSTANCE_CPU_AGGREGATE_IS_ERROR,
  FETCH_INSTANCE_CPU_AGGREGATE_IS_PENDING,
  FETCH_INSTANCE_DISTRIBUTION_CURRENT,
  FETCH_INSTANCE_DISTRIBUTION_CURRENT_IS_ERROR,
  FETCH_INSTANCE_DISTRIBUTION_CURRENT_IS_PENDING,
  FETCH_INSTANCE_DISTRIBUTION_HISTORY,
  FETCH_INSTANCE_DISTRIBUTION_HISTORY_IS_ERROR,
  FETCH_INSTANCE_DISTRIBUTION_HISTORY_IS_PENDING,
  FETCH_INSTANCE_MEMORY_AGGREGATE,
  FETCH_INSTANCE_MEMORY_AGGREGATE_IS_ERROR,
  FETCH_INSTANCE_MEMORY_AGGREGATE_IS_PENDING,
} from 'services/Telemetry/ApplicationInstance/types';

const telemetryApplicationInstanceReducer = (
  state = {
    instanceMemoryAggregate: [],
    fetchInstanceMemoryAggregateIsCompleted: false,
    fetchInstanceMemoryAggregateIsPending: false,
    fetchInstanceMemoryAggregateIsError: null,

    instanceCPUAggregate: [],
    fetchInstanceCPUAggregateIsCompleted: false,
    fetchInstanceCPUAggregateIsPending: false,
    fetchInstanceCPUAggregateIsError: null,

    fetchInstanceDistributionCurrentIsCompleted: false,
    fetchInstanceDistributionCurrentIsPending: false,
    fetchInstanceDistributionCurrentIsError: null,

    fetchInstanceDistributionHistoryIsCompleted: false,
    fetchInstanceDistributionHistoryIsPending: false,
    fetchInstanceDistributionHistoryIsError: null,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_INSTANCE_MEMORY_AGGREGATE:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        instanceMemoryAggregate: action.data.data,
        fetchInstanceMemoryAggregateIsCompleted: true,
        fetchInstanceMemoryAggregateIsPending: false,
        fetchInstanceMemoryAggregateIsError: null,
      };
    case FETCH_INSTANCE_MEMORY_AGGREGATE_IS_PENDING:
      return {
        ...state,
        fetchInstanceMemoryAggregateIsCompleted: false,
        fetchInstanceMemoryAggregateIsPending: true,
        fetchInstanceMemoryAggregateIsError: null,
      };
    case FETCH_INSTANCE_MEMORY_AGGREGATE_IS_ERROR:
      return {
        ...state,
        fetchInstanceMemoryAggregateIsCompleted: true,
        fetchInstanceMemoryAggregateIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchInstanceMemoryAggregateIsError: action.error,
      };

    case FETCH_INSTANCE_CPU_AGGREGATE:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        instanceCPUAggregate: action.data.data,
        fetchInstanceCPUAggregateIsCompleted: true,
        fetchInstanceCPUAggregateIsPending: false,
        fetchInstanceCPUAggregateIsError: null,
      };
    case FETCH_INSTANCE_CPU_AGGREGATE_IS_PENDING:
      return {
        ...state,
        fetchInstanceCPUAggregateIsCompleted: false,
        fetchInstanceCPUAggregateIsPending: true,
        fetchInstanceCPUAggregateIsError: null,
      };
    case FETCH_INSTANCE_CPU_AGGREGATE_IS_ERROR:
      return {
        ...state,
        fetchInstanceCPUAggregateIsCompleted: true,
        fetchInstanceCPUAggregateIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchInstanceCPUAggregateIsError: action.error,
      };

    case FETCH_INSTANCE_DISTRIBUTION_CURRENT:
      return {
        ...state,
        fetchInstanceDistributionCurrentIsCompleted: true,
        fetchInstanceDistributionCurrentIsPending: false,
        fetchInstanceDistributionCurrentIsError: null,
      };
    case FETCH_INSTANCE_DISTRIBUTION_CURRENT_IS_PENDING:
      return {
        ...state,
        fetchInstanceDistributionCurrentIsCompleted: false,
        fetchInstanceDistributionCurrentIsPending: true,
        fetchInstanceDistributionCurrentIsError: null,
      };
    case FETCH_INSTANCE_DISTRIBUTION_CURRENT_IS_ERROR:
      return {
        ...state,
        fetchInstanceDistributionCurrentIsCompleted: true,
        fetchInstanceDistributionCurrentIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchInstanceDistributionCurrentIsError: action.error,
      };
    case FETCH_INSTANCE_DISTRIBUTION_HISTORY:
      return {
        ...state,
        fetchInstanceDistributionHistoryIsCompleted: true,
        fetchInstanceDistributionHistoryIsPending: false,
        fetchInstanceDistributionHistoryIsError: null,
      };
    case FETCH_INSTANCE_DISTRIBUTION_HISTORY_IS_PENDING:
      return {
        ...state,
        fetchInstanceDistributionHistoryIsCompleted: false,
        fetchInstanceDistributionHistoryIsPending: true,
        fetchInstanceDistributionHistoryIsError: null,
      };
    case FETCH_INSTANCE_DISTRIBUTION_HISTORY_IS_ERROR:
      return {
        ...state,
        fetchInstanceDistributionHistoryIsCompleted: true,
        fetchInstanceDistributionHistoryIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchInstanceDistributionHistoryIsError: action.error,
      };
    case 'RESET_REDUCER':
      return {
        ...state,
        fetchInstanceStatusIsCompleted: false,
        fetchInstanceStatusIsPending: false,
        fetchInstanceStatusIsError: null,
        instanceStatusAggregate: {},
        fetchInstanceStatusAggregateIsCompleted: false,
        fetchInstanceStatusAggregateIsPending: false,
        fetchInstanceStatusAggregateIsError: null,
        providerInstanceAggregate: {},
        fetchInstanceProviderIdAggregateIsCompleted: false,
        fetchInstanceProviderIdAggregateIsPending: false,
        fetchInstanceProviderIdAggregateIsError: null,
        fetchInstanceProviderIdIsCompleted: false,
        fetchInstanceProviderIdIsPending: false,
        fetchInstanceProviderIdIsError: null,

        instanceMemoryAggregate: [],
        fetchInstanceMemoryAggregateIsCompleted: false,
        fetchInstanceMemoryAggregateIsPending: false,
        fetchInstanceMemoryAggregateIsError: null,

        instanceCPUAggregate: [],
        fetchInstanceCPUAggregateIsCompleted: false,
        fetchInstanceCPUAggregateIsPending: false,
        fetchInstanceCPUAggregateIsError: null,

        fetchInstanceDistributionCurrentIsCompleted: false,
        fetchInstanceDistributionCurrentIsPending: false,
        fetchInstanceDistributionCurrentIsError: null,

        fetchInstanceDistributionHistoryIsCompleted: false,
        fetchInstanceDistributionHistoryIsPending: false,
        fetchInstanceDistributionHistoryIsError: null,
      };
    default:
      return state;
  }
};

export default telemetryApplicationInstanceReducer;
